module.exports = __webpack_public_path__ + "img/down_arrow_icon.ca1705a6.svg";